export type Map3DFeatures = 'hillshade' | 'contours' | 'buildings';
export type BackgroundMap = 'none' | 'street' | 'dark' | 'light' | 'outdoors' | 'satstrets';
export type Map3DFeatureCommaList = string;
export type PrimaryPanelStartViews = 'layers' | 'search'
export type PrimaryPanelStartViewCommaList = string;
export type SecondaryPanelStartViews = 'legend' | 'camera';
export type SecondaryPanelStartViewCommaList = 'legend' | 'camera';
export type MouseInput = 'pt_query' | 'pt_query_vis' | 'roi_query' | 'roi_query_vis'
export type LayerIDString = string;
export type NumericBoolString = '1' | '0'
export type CriteriaString = string;
export type NumberString = string;
export type SuppressionMaskHex = NumberString;
export enum SuppressionMask {
  location = 1 << 0,
  navigation = 1 << 1,
  buffer = 1 << 2,
  info_modes = 1 << 3,
  gps_tools = 1 << 4,
  query_vis_all = 1 << 5,
  memory_tools = 1 << 6,
  camera = 1 << 7,
  map_background = 1 << 8,
  map_3d = 1 << 9,
  hover_tip = 1 << 10,
  browser_tools = 1 << 11,
  pdf = 1 << 12,
  layer_cfg = 1 << 13,
  adv_results = 1 << 14,
  unsynchable = 1 << 15,
  layers = 1 << 16,
  legend = 1 << 17,
  search = 1 << 18,
  query = 1 << 19,
  attribute = 1 << 20,
  attribute_editor = 1 << 21,
  ALL = (1 << 22) - 1
}
export enum SuppressionMask2 {
  panels = 1 << 0,
  primary_panel = 1 << 1,
  secondary_panel = 1 << 2,
  extended_panel = 1 << 3,
  editor = 1 << 4,
  classification = 1 << 5,
  title_footer = 1 << 6,
  ALL = (1 << 7) - 1

}
export type ExtraParams = {
  bg?: BackgroundMap, // backgroundMap
  tool?: string, // tool group (default nav ) viewer-only
  "3d"?: Map3DFeatureCommaList, // [hillshade][,contours][,buildings]
  mapint?: string, // [hovertip][,nohdrftr][,gpscenter]
  ppanel?: PrimaryPanelStartViewCommaList | Array<string> | 'hidden' | undefined, // primary panel view [layers | search],[[open|closed].[collapsed|expanded]]
  spanel?: SecondaryPanelStartViewCommaList | Array<string> | 'hidden' | undefined, // secondary panel view [legend | camera],[[open|closed].[collapsed|expaned]
  input?: MouseInput, // [pt_query|pt_query_vis|roi_query|roi_query_vis] # vis varients only on viewer
  query_vis_only?: string, // [1|0]
  def_capture_layer?: LayerIDString, // layer id to use as default for the capture/digitizer layer
  search?: LayerIDString, // layer id of search layer
  criteria?: CriteriaString, // [field_name]:[comparison]:[value]
  auto?: string, // auto search [1|0]
  query?: string, // auto query [auto|auto-single]
  qlayer?: string, // query layer [layer id]
  buffer?: string, // buffer diameter in meters
  zoom?: string, // auto zoom to results [1|0]
  spatial_query?: 'puc' | 'results',
  searches?: 'puc' | 'results'
  suppressions?: SuppressionMaskHex
}
export type Suppressable = keyof typeof SuppressionMask | keyof typeof SuppressionMask2 | number;
export function IsSuppressing(mask: SuppressionMaskHex, feature: Suppressable) {
  if(!mask) return false;
  if(!feature) return false;
  const mask1 = mask.substring(mask.length - 16);
  mask = mask.substring(0, mask.length - 16);
  let mask2 = '';
  if (mask.length > 0) {
    mask2 = mask.substring(mask.length - 16);
  }

  if (feature in SuppressionMask) {
    const suppressedFeature = (typeof feature === 'number') ? 1 << feature : SuppressionMask[feature];
    return (Number.parseInt(mask1, 16) & suppressedFeature) > 0;
  }
  if (feature in SuppressionMask2) {
    const suppressedFeature = (typeof feature === 'number') ? 1 << feature : SuppressionMask2[feature];
    return (Number.parseInt(mask2, 16) & suppressedFeature) > 0;
  }
  return false;
}

export function GetMaxSuppression(mask: SuppressionMaskHex): number {
  const maskVal = Number.parseInt(mask, 16)
  let testVal = Number.parseInt('FFFF', 16)
  let i = 16;
  for (i = 16; i > 0; i -= 1) {
    if (testVal <= maskVal) break;
    testVal -= (1 << i);
  }
  return i;
}
export type ExtraParamSet = {
  [key:string]: ExtraParams
}
export const extraParamsPresets:ExtraParamSet = {
  'full-viewer': {
    spatial_query: 'puc'
  },
  'minimal': {
    bg: 'dark',
    mapint: 'hovertip',
    ppanel: 'layers,opened.expanded'.split(','),
    spanel: 'legend,opened.expanded'.split(','),
    query_vis_only: 'true',
    suppressions: 'FA7D'
  },
  'sparse': {
    bg: 'dark',
    mapint: 'hovertip',
    ppanel: 'hidden',
    spanel: 'hidden',
    query_vis_only: 'true',
    suppressions:

      SuppressionMask2.ALL.toString(16).padStart(16, '0')
      + (SuppressionMask.ALL -
        (
          SuppressionMask.location
          | SuppressionMask.navigation
          | SuppressionMask.map_background
          | SuppressionMask.hover_tip
        )).toString(16).padStart(16, '0')
  }
}
